/* template */
<template><div class="popup"><ts-mask :show="(show && showMask)" :closeable="(closeable)" @close="close" :externStyle="(computedMaskStyle)"/><div :class="([lowerZIndex,position,className])" :style="[(externStyle)] | transRpxStyle" class="transition"><slot></slot></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0ce21716"}'>
  .popup
    max-height 100%
    overflow-y auto
    touch-action none
  .center
    top 50%
    left 50%
  .top
    top 0
    left 0
    width 100%
  .bottom
    bottom 0
    left 0
    width 100%
  .left
    top 50%
    left 0
  .right
    top 50%
    right 0
  .transition
    position fixed
    transition-timing-function ease
    transition-duration 300ms
    transition-property opacity, transform, visibility
    touch-action none
    z-index 700
  .drawer
    z-index 600
  .fade-enter-to, .fade-leave
    opacity 1
  .fade-enter, .fade-leave-to
    opacity 0
  .center-enter, .center-leave-to
    transform translate3d(-50%, -50%, 0) scale(0.9)
    opacity 0
    visibility hidden
  .center-enter-to, .center-leave
    transform translate3d(-50%, -50%, 0)
    opacity 1
    visibility visible
  .bottom-enter, .bottom-leave-to
    transform translate3d(0, 100%, 0)
  .top-enter, .top-leave-to
    transform translate3d(0, -100%, 0)
  .left-enter, .left-leave-to
    transform translate3d(-100%, -50%, 0)
  .left-enter-to, .left-leave
    transform translate3d(0, -50%, 0)
  .right-enter, .right-leave-to
    transform translate3d(100%, -50%, 0)
  .right-enter-to, .right-leave
    transform translate3d(0, -50%, 0)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0ce21716"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex0ce21716%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex0ce21716%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0ce21716"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index0ce21716/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'ts-mask':getComponent(require("../ts-mask/index.mpx?isComponent&outputPath=components%2Findex778d9a52%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
